import React from "react";
import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";

export default function BarcarenaDrs(){

  return(

    <>
    <Helmet title="Barcarena DRS - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="BARCARENA DRS" link1={"Projetos/ "} link2={"BARCARENA-DRS"} />
      <section id="context">
        <div className="container">

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                    Barcarena DRS
                </h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Prestação de serviços de Laboratório de Mecânica dos Solos para o DRS na Hydro Alunorte em Barcarena – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0"
            >
                <h2>Informações do Projeto</h2>
                <ul>
                  <li><strong>Cliente: </strong> Hydro</li>
                  <li><strong>Cidade: </strong> Barcarena - PA </li>
                  <li><strong>Ano: </strong> 2019 </li>
                  <li><strong>Segmento: </strong> Engenharia Civil </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />

      <Ouvidoria/>
    </>
  )
}